import { CustomerTypePipe } from './customer.type.pipe';

export function CustomerTypeFilter ( customerTypePipe : CustomerTypePipe ) {
  return ( value : string, html : boolean ) : string => customerTypePipe.transform(value, html);
}
